import styled from 'styled-components';

export const Main = styled.div<{ $isLoading?: boolean }>`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${({ $isLoading }) =>
    $isLoading &&
    `
      width: 430px;
      height: 154px;
    `}
`;

export const Heading = styled.div`
  font-size: 14px;
  font-weight: 700;
  text-align: center;
`;
